export default {
  message: {
    "strid1": "HOME",
    "strid2": "ABOUT MLBB",
    "strid3": "ESPORTS",
    "strid4": "COMMUNITY",
    "strid5": "LANGUAGE",
    "strid6": "everyone can be a legend",
    "strid7": "VIDEO",
    "strid8": "MORE",
    "strid9": "Privacy Policy",
    "strid10": "Terms of Service",
    "strid11": "© MOONTON Corporation.All rights reserved.",
    "strid12": "GLOBAL OVERVIEW",
    "strid13": "GALLERY",
    "strid14": "FAN WORKS",
    "strid15": "INFLUENCER",
    "strid16": "JOIN MLBB CREATOR CAMP",
  }
}
